import { DistrictDataBySchool } from '@peekapak/types/ReportDataExchangeTypes';
import SortableTable from '../Tables/SortableTable';
import { getTotalRow } from '../reportUtilities';

interface Props {
  data: DistrictDataBySchool;
  topFiveSchools: string[];
  onSchoolClick?: (schoolName: string) => void;
}

const DistrictDataTable = ({ data, topFiveSchools, onSchoolClick }: Props) => {
  const columns = [
    {
      label: 'School Name',
      accessor: 'school_name',
      sortable: false,
      clickable: (rowData: { school_name?: string }) => !!onSchoolClick && rowData.school_name !== 'Other',
      onClick: onSchoolClick
        ? (rowData: { school_name?: string }) => {
            if (rowData.school_name && rowData.school_name !== 'Other') onSchoolClick(rowData.school_name);
          }
        : undefined,
      renderTooltip: onSchoolClick
        ? (rowData: { school_name?: string }) =>
            rowData.school_name && rowData.school_name !== 'Other' ? `View ${rowData.school_name} school report` : null
        : undefined,
    },
    {
      label: 'Number of Staff',
      accessor: 'number_of_educators',
      sortable: true,
      tooltip: 'Number of staff at the listed school who have been active during the time period',
    },
    {
      label: 'Staff Logins',
      accessor: 'educator_logins',
      sortable: true,
    },
    {
      label: 'Student Logins',
      accessor: 'student_logins',
      sortable: true,
    },
    {
      label: 'Story Opens',
      accessor: 'story_opens',
      sortable: true,
      tooltip:
        'Number of times an elementary storybook or a secondary school human interest story was accessed by a user at this school',
    },
    {
      label: 'Lessons Accessed',
      accessor: 'lessons_accessed',
      sortable: true,
      tooltip: 'Total number of times an educator at this school accessed a lesson',
    },
    {
      label: 'Time on Platform (hrs)',
      accessor: 'time_on_platform',
      sortable: true,
      tooltip: 'Total time educators, admin and students, spent on the platform',
    },
  ];

  const totalsRow = getTotalRow(data);
  return <SortableTable data={data} columns={columns} totals={totalsRow} defaultSortField='educator_logins' />;
};

export default DistrictDataTable;
